/**
 * Gets the line item or creative id from the provided keyvalue or if
 * not present returns the string "none".
 *
 * @param value The keyvalue to retrieve the uap and uap_c ids from
 * @returns The string version of the ids or "none" if the value is not present.
 */
export function retrieveUapKeyValue(value: number | undefined) {
  return value ? value.toString() : "none";
}
